import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProjectChecklistProfileDialogComponent } from '@portal-core/project-checklists/components/project-checklist-profile-dialog/project-checklist-profile-dialog.component';
import { ProjectChecklist } from '@portal-core/project-checklists/models/project-checklist.model';
import { AvatarBase } from '@portal-core/ui/avatar/util/avatar.base';

@Component({
  selector: 'mc-project-checklist-avatar',
  templateUrl: './project-checklist-avatar.component.html',
  styleUrls: ['./project-checklist-avatar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectChecklistAvatarComponent extends AvatarBase {
  @Input() checklist: ProjectChecklist;

  get name(): string {
    if (this.checklist) {
      return this.checklist.Name;
    }
  }

  get tooltip(): string {
    if (this.checklist) {
      return this.checklist.Name;
    }
  }

  constructor(private dialog: MatDialog) {
    super();
  }

  onAvatarClicked() {
    this.openProjectChecklistProfileDialog();
  }

  hasAvatarImage(): boolean {
    return false;
  }

  hasPermission(): boolean {
    return true;
  }

  isDeleted(): boolean {
    return this.checklist?.IsDeleted;
  }

  isEmpty(): boolean {
    return !this.checklist;
  }

  private openProjectChecklistProfileDialog() {
    this.dialog.open(ProjectChecklistProfileDialogComponent, {
      ...ProjectChecklistProfileDialogComponent.DialogConfig,
      data: {
        checklistId: this.checklist.Id
      }
    });
  }
}
